/* eslint-disable complexity */
import React, { Fragment } from 'react';
import posed from 'react-pose';
import styled from 'styled-components';

import { ArrowRightIcon } from '../../icons/svgs';
import Loading from '../../loading/Loading';
import TEST_IDS from '../../../utils/_tests/testIds.constants';

type Props = {
    background: string;
    color: string;
    isDisabled: boolean;
    isLoading: boolean;
    label: string;
    onClick: () => void;
    styles: any;
    loadingStyles: any;
}
const RoundedButtonWithArrow = ({
    background,
    color,
    isDisabled,
    isLoading,
    label,
    onClick,
    styles,
    loadingStyles,
    ...props
}: Props) => (
    <AnimatedWrapper
        isLoading={isLoading}
    >
        <SubscribeButton
            data-testid={TEST_IDS.INPUTS.ROUNDED_BUTTON_WITH_ARROW}
            backgroundColor={background}
            color={color}
            onClick={onClick}
            styles={styles}
            type="submit"
            disabled={isDisabled}
            {...props}
        >

            {isLoading && (
                <Loading
                    backgroundColor={
                        loadingStyles?.backgroundColor || '#ffffff'
                    }
                    height={
                        loadingStyles?.height || '100%'
                    }
                />
            )}

            {!isLoading && (
                <Fragment>
                    <AnimatedText>{label}</AnimatedText>
                    <AnimatedIcon
                        pose={isLoading ? 'visible' : 'hidden'}
                    >
                        {!isDisabled && (
                            <ArrowRightIcon
                                backgroundColor={styles.color}
                                height={13}
                                width={13}
                            />
                        )}
                    </AnimatedIcon>
                </Fragment>
            )}


        </SubscribeButton>
    </AnimatedWrapper>
);

RoundedButtonWithArrow.defaultProps = {
    background: null,
    color: '#ffffff',
    isDisabled: false,
    isLoading: false,
    label: null,
    onClick: null,
    styles: {
        color: '#ffffff',
    },
    loadingStyles: {
        backgroundColor: '#ffffff',
        height: '100%',
    },
};

const SubscribeButton = styled.button`
    background: ${({ backgroundColor }) => backgroundColor || '#73e293'};
    color: ${({ color }) => color || '#ffffff'};
    border-radius: 22px;
    min-height: 50px;
    width:200px;

    ${({ styles }) => styles && { ...styles }};
`;

const AnimatedWrapper = posed.div({
    hoverable: true,
});

const AnimatedIcon = posed.span({
    init: {
        left: 0,
        opacity: 0,
        position: 'relative',
        top: 2,
    },
    hover: {
        transform: 'translateX(6px)',
        opacity: 1,
        left: 5,
    },
});

const AnimatedText = posed.span({
    init: {
        position: 'relative',
        right: -5,
    },
    hover: {
        transform: 'translateX(6px)',
        right: 0,
    },
});

export default RoundedButtonWithArrow;
